import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import VehiclesList from '../../containers/vehicles/VehiclesList'
import ViewVehicle from '../../containers/vehicles/ViewVehicle'
import CreateVehicle from './create-vehicle/CreateVehiclePane'
import EditVehiclePane from './edit-vehicle/EditVehiclePane'
import ErrorBoundary from '../ErrorBoundary'
import AssignVehicelOperator from '../../containers/vehicles/AssignVehicleOperator'
const VehiclesPane = (props: RouteComponentProps<any>) => {
  const vehicleListActive = (props: any) => {
    return <VehiclesList list={'active'} {...props} />
  }
  const vehicleListDeactivated = (props: any) => {
    return <VehiclesList list={'deactivated'} {...props} />
  }
  return (
    <ErrorBoundary>
      <Switch>
        <Route path={`${props.match.path}/`} exact={true} component={vehicleListActive} />
        <Route path={`${props.match.path}/deactivated`} component={vehicleListDeactivated} />
        <Route path={`${props.match.path}/view/:id`} component={ViewVehicle} />
        <Route path={`${props.match.path}/create/`} component={CreateVehicle} />
        <Route path={`${props.match.path}/edit`} component={EditVehiclePane} />
        <Route path={`${props.match.path}/:vehicleId/assign-operator`} exact={true} component={AssignVehicelOperator} />
      </Switch>
    </ErrorBoundary>
  )
}

export default VehiclesPane



// WEBPACK FOOTER //
// ./src/components/vehicles/VehiclesPane.tsx